import React, { useContext, useState, useEffect } from 'react'

import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import { mapData, handleRedirectInternal } from '@/product/common/components'
import UserView from '@/views/Listing/UserView'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import * as Yup from 'yup'
import GroupContext from '@/product/context/group/groupContext'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomDialog from '@/product/components/organisms/Dialog'
import { Button } from '@mui/material'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import ProductContext from '@/product/context/product/productContext'
import Cart from '@/product/context/cart/cartContext'
import Layout from '@/product/components/templates/Layout'
const PrivateAuction = (props) => {
    const groupContext = useContext(GroupContext)
    const [isLoading, setIsLoading] = useState(true)
    const [changeStatus, setChangeStatus] = useState(false)
    const [tableBody, setTableBody] = useState([])
    const [detail, setDetail] = useState({})
    const productContext = useContext(ProductContext)

    const cart = useContext(Cart)

    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const {
        addToCartbySeller,
        responseStatus: cartResponseStatus,
        clearResponse: clearCartResponse,
    } = cart
    const {
        getProjectAccessRequest,
        all_project_access_req,
        projectAccessReqStatus,
        responseStatus: productResponseStatus,
        clearResponse: clearResponseProduct,
    } = productContext
    const data = props.data
    const toggleFullScreenPopup = props.function

    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
    })

    const toggleFullScreenUserPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const userFormik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: 'par.id,desc',
            action: 0,
            // searchterm: '',
            // group_id: 0,
            filters: {
                auctionid: {
                    value: 0,
                    type: 'in',
                    field: 'par.project_id',
                },
                searchterm: {
                    value: '',
                    type: 'like',
                    field: 'u.first_name',
                },
                // approved: {
                //     value: '',
                //     type: 'in',
                //     field: 'par.approved_type',
                // },
                approved: {
                    value: '',
                    type: 'in',
                    field: 'par.approved_status',
                },
            },
            tableJoins: [
                {
                    baseTable: 'users',
                    customTable: 'custom_users',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'requested_user_id',
                },
                {
                    baseTable: 'projects',
                    customTable: 'custom_projects',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'project_id',
                },
                {
                    baseTable: 'employees',
                    // customTable: 'custom_projects',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'seller_id',
                },
            ],
        },

        onSubmit: (values) => {
            setIsLoading(true)
            values.filters.searchterm.value = values.searchterm
            getProjectAccessRequest(values, 'registedUser')
        },
    })

    useEffect(() => {
        if (
            productResponseStatus &&
            productResponseStatus.from === 'projectAccessReqStatus'
        ) {
            if (productResponseStatus.status === 'success') {
                setTableBody([])
                setIsLoading(true)

                if (
                    detail?.project_id > 0 &&
                    detail?.project_qty > 0 &&
                    detail?.approved_status !== 'approved' &&
                    !detail.projects_auction &&
                    formikSelection?.values?.approved
                ) {
                    ;({
                        cart: [
                            {
                                product_id: detail?.project_id,
                                qty: detail?.project_qty,
                            },
                        ],
                        buyer_id: detail?.requested_user_id,
                    })
                } else if (
                    detail?.project_id > 0 &&
                    detail?.projects_qty > 0 &&
                    detail?.approved_status !== 'approved' &&
                    !detail.projects_auction &&
                    formikSelection?.values?.approved
                ) {
                    addToCartbySeller({
                        cart: [
                            {
                                product_id: detail?.project_id,
                                qty: detail?.projects_qty,
                            },
                        ],
                        buyer_id: detail?.requested_user_id,
                    })
                }
                //  else {
                //     setAlert(
                //         productResponseStatus.message,
                //         productResponseStatus.status
                //     )
                // }

                userFormik.values.page = 1
                userFormik.values.filters.auctionid.value = data?.id
                getProjectAccessRequest(userFormik.values, 'registedUser')
                changeChangeStatus()
            }
            clearResponseProduct()
        }
    }, [productResponseStatus])

    useEffect(() => {
        if (cartResponseStatus) {
            if (cartResponseStatus.from === 'addToCartbySeller') {
                if (cartResponseStatus.status === 'success') {
                    // setAlert('Successfully Updated!', cartResponseStatus.status)
                    // handleRedirectInternal(history, 'singlecart')

                    clearCartResponse()
                } else {
                    setAlert(
                        cartResponseStatus.message,
                        cartResponseStatus.status
                    )
                }
            }
        }
    }, [cartResponseStatus])

    useEffect(() => {
        if (
            all_project_access_req &&
            all_project_access_req.from === 'registedUser'
        ) {
            const data = all_project_access_req?.records?.map((el) => {
                const isVisible =
                    el.projects_market_status === 'open' &&
                    el.approved_status == 'pending'

                return {
                    ...el,
                    visible_status: isVisible,
                }
            })

            setTableBody(data?.length ? data : [])
            // setTableBody(
            //     all_project_access_req.records.length
            //         ? all_project_access_req.records
            //         : []
            // )
            setIsLoading(false)
        }
    }, [all_project_access_req])

    const onClickEdit = (id, secondaryID, type) => {
        if (all_project_access_req && all_project_access_req.records.length) {
            let userDetail = all_project_access_req.records.find(
                (ele) => ele.id == id
            )
            setDetail(userDetail)
            if (type === 'edit') {
                formikSelection.values.approved = 1
                formikSelection.values.auto_approved = 1
                formikSelection.values.approved_status = 'approved'
                formikSelection.values.approved_date = new Date()
                setChangeStatus(true)
            } else if (type === 'view') {
                toggleFullScreenUserPopup(true, 'edit', secondaryID)
            } else {
                formikSelection.values.approved = 0
                formikSelection.values.auto_approved = 0
                formikSelection.values.approved_status = 'rejected'
                setChangeStatus(true)
            }
        }

        //  toggleFullScreenPopup(true, type, id)
    }

    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'recommend',
                clickType: 'edit',
                onclick: onClickEdit,
                tooltipTitle: 'Approve user',
                disabledField: 'approved',
                disabledType: true,
                condition: true,
                conditionValue: {
                    formula: {
                        key1: 'visible_status',
                        key2: true,
                        notation: '===',
                        isString: true,
                    },
                },
            },
            {
                buttonType: 'cancel',
                clickType: 'cancel',
                onclick: onClickEdit,
                tooltipTitle: 'Reject User',
                condition: true,
                conditionValue: {
                    formula: {
                        key1: 'visible_status',
                        key2: true,
                        notation: '===',
                        isString: true,
                    },
                },
            },
            {
                buttonType: 'library_add_check',
                clickType: 'view',
                onclick: onClickEdit,
                tooltipTitle: 'View User Details',
            },
        ]
        return actionPush
    }
    useEffect(() => {
        // if (data.id > 0) {
        setTableBody([])
        setIsLoading(true)
        userFormik.values.page = 1
        // userFormik.values.filters.auctionid.value = data.id
        userFormik.values.filters.searchterm.value = ''
        userFormik.values.filters.approved.value = 0
        userFormik.values.searchterm = ''

        getProjectAccessRequest(userFormik.values, 'registedUser')
        // }
    }, [])

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
        },
        {
            field: 'users_first_name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'TB First Name',
        },
        {
            field: 'users_last_name',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'TB Last Name',
        },
        {
            field: 'as_employees_emp_firstname',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'TG First Name',
        },
        {
            field: 'as_employees_emp_lastname',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'TG Last Name',
        },
        {
            field: 'users_companyname',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Company Name',
        },
        {
            field: 'projects_title',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Offer Title',
        },
        {
            field: 'projects_market_status',
            type: '',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Offer Status',
        },

        // {
        //     field: 'request_notes',
        //     type: '',
        //     firstChild: false,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Request Notes',
        // },
        {
            field: 'request_notes',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Request Notes',
            tooltipTitle: 'request_notes',
            compressString: true,
            condition: true,
        },
        {
            field: 'approved_status',
            type: 'capitalize',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        },
        {
            field: 'created_at',
            type: 'datetime',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Request Date',
        },
        {
            field: 'approved_date',
            type: 'datetime',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'IOI Approval/Reject Date',
        },

        {
            field: 'approve_notes',
            type: '',
            firstChild: false,
            sort: true,
            disablePadding: false,
            label: 'Approve/Reject Notes',
            tooltipTitle: 'approve_notes',
            compressString: true,
            condition: true,
        },
        // {
        //     field: 'approve_notes',
        //     type: '',
        //     firstChild: false,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Approve/Reject Notes',
        // },
        {
            field: 'action',
            type: 'button',
            clickID: 'id',
            secondaryClickID: 'users_id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
        },
    ]

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
        formikSelection.resetForm()
    }

    const searchInfo = {
        formik: userFormik,
        data: [
            {
                label: 'First Name',
                placeholder: 'Enter Name',
                class: 'col-md-4 col-sm-6 col-12',
                type: 'text',
                name: 'searchterm',
            },
            {
                label: 'Status',
                placeholder: 'Enter status',
                class: 'col-sm-6 col-12',
                filter: true,
                type: 'select',
                options: [
                    { value: '', show: 'All' },
                    { value: 'pending', show: 'Pending' },
                    { value: 'approved', show: 'Approved' },
                    { value: 'rejected', show: 'Restrict' },
                ],
                name: 'approved',
            },
        ],
    }

    const formikSelection = useFormik({
        initialValues: {
            id: 0,
            approved: 0,
            auto_approved: 0,
            onlyBidding: true,
            project_id: 0,
            approved_status: '',
            approve_notes: '',
        },
        onSubmit: (values) => {
            if (detail?.id > 0) {
                values.id = detail.id
                values.project_id = detail.project_id
                values.requested_user_id = detail.requested_user_id
                projectAccessReqStatus(values)
            }
        },
    })

    const rejectNotes = {
        formik: formikSelection,
        data: [
            {
                label: 'Notes',
                placeholder: 'Enter Notes',
                class: `col-12`,
                type: 'textarea',
                name: 'approve_notes',
            },
        ],
    }

    const closeUpdate = () => {
        getProjectAccessRequest(userFormik.values, 'registedUser')
    }

    return (
        <Layout>
            <div className="">
                <CustomSearch searchInfo={searchInfo} formik={userFormik} />
                {isLoading ? (
                    <div>Loading....</div>
                ) : (
                    <CustomTable
                        formik={userFormik.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={[]}
                        allData={all_project_access_req}
                        isLoading={isLoading}
                        loadingTemplate={'table'}
                        changeTableFunction={getProjectAccessRequest}
                        fromVariable={'registedUser'}
                    />
                )}
            </div>

            <CustomDialog
                title={'Change user status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    Are you sure you want to{' '}
                    {formikSelection.values.approved ? 'Approved' : 'Restrict'}{' '}
                    {detail.users_email}
                </h5>
                <div className="row">{mapData(rejectNotes)}</div>

                <div className="actionWrapper">
                    <Button onClick={() => changeChangeStatus()}>Cancel</Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton type="submit" label="Confirm" />
                    </form>
                </div>
            </CustomDialog>
            <UserView
                data={manage}
                function={toggleFullScreenUserPopup}
                closeUpdate={closeUpdate}
            />
        </Layout>
    )
}

export default PrivateAuction
